/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import { useBreakpoint } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Partners, usePartner } from '@shared/lib/partner';
import { Content } from '@shared/ui/atoms';
import MTSLogo from './old_logo/MTSLogo';
const OldHeader: FC = () => {
  const {
    partner
  } = usePartner();
  const {
    isMobile
  } = useBreakpoint();
  const router = useRouter();
  const isMobileVanta = partner === Partners.VANTA && isMobile;
  const isPayQRPage = router.asPath.includes('pay-qr');
  const isPubgGiveawayPage = router.asPath.includes('rozygrysh-prizov-pubg-mobile');
  const isVesenniiRozygrysh2026Page = router.asPath.includes('vesennii-rozygrysh-prizov-2026');
  const isGenshinPubgResultsPage = router.asPath.includes('rozygrysh-prizov-genshin-pubg-itogi');
  const isDvoinoiShansNaPobeduPage = router.asPath.includes('dvoinoi-shans-na-pobedu');
  const isDvoinoiShansNaPobeduResultsPage = router.asPath.includes('dvoinoi-shans-na-pobedu-itogi');
  return <CyberHeaderWrapper isPayQRPage={isPayQRPage} isPubgGiveawayPage={isPubgGiveawayPage} isVesenniiRozygrysh2026Page={isVesenniiRozygrysh2026Page} isGenshinPubgResultsPage={isGenshinPubgResultsPage} isDvoinoiShansNaPobeduPage={isDvoinoiShansNaPobeduPage} isDvoinoiShansNaPobeduResultsPage={isDvoinoiShansNaPobeduResultsPage}>
      <Content.Padding left={isPayQRPage ? 64 : 40} right={40} mobLeft={24} mobRight={24} minLeft={20} minRight={20}>
        <Container isPayQRPage={isPayQRPage}>
          <SearchWrraper id="header" isMobileVanta={isMobileVanta}>
            <LogoWrapper isPayQRPage={isPayQRPage} isPubgGiveawayPage={isPubgGiveawayPage} isVesenniiRozygrysh2026Page={isVesenniiRozygrysh2026Page} isDvoinoiShansNaPobeduPage={isDvoinoiShansNaPobeduPage} isDvoinoiShansNaPobeduResultsPage={isDvoinoiShansNaPobeduResultsPage} isMobileVanta={isMobileVanta}>
              <MTSLogo />
            </LogoWrapper>
          </SearchWrraper>
        </Container>
      </Content.Padding>
    </CyberHeaderWrapper>;
};
export default OldHeader;
interface CyberHeaderWrapperProps {
  isPayQRPage: boolean;
  isPubgGiveawayPage: boolean;
  isVesenniiRozygrysh2026Page: boolean;
  isGenshinPubgResultsPage: boolean;
  isDvoinoiShansNaPobeduPage: boolean;
  isDvoinoiShansNaPobeduResultsPage: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isPayQRPage,
  isPubgGiveawayPage,
  isVesenniiRozygrysh2026Page,
  isDvoinoiShansNaPobeduPage,
  isDvoinoiShansNaPobeduResultsPage,
  theme
}) => isPayQRPage ? '#000000' : isPubgGiveawayPage ? '#222222' : isVesenniiRozygrysh2026Page ? '#102248' : isDvoinoiShansNaPobeduPage || isDvoinoiShansNaPobeduResultsPage ? '#2EA9BC' : theme.colors.bg.black;
const _exp2 = /*#__PURE__*/() => ({
  isPayQRPage,
  isVesenniiRozygrysh2026Page,
  isGenshinPubgResultsPage,
  isDvoinoiShansNaPobeduPage,
  isDvoinoiShansNaPobeduResultsPage
}) => isPayQRPage || isVesenniiRozygrysh2026Page || isGenshinPubgResultsPage || isDvoinoiShansNaPobeduPage || isDvoinoiShansNaPobeduResultsPage ? '0' : '0';
const CyberHeaderWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "CyberHeaderWrapper",
  class: "cns7g26",
  propsAsIs: false,
  vars: {
    "cns7g26-0": [_exp()],
    "cns7g26-1": [_exp2()]
  }
}));
const _exp3 = /*#__PURE__*/() => ({
  isPayQRPage
}) => isPayQRPage ? '1520px' : '1016px';
const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "c1ijassw",
  propsAsIs: false,
  vars: {
    "c1ijassw-0": [_exp3()]
  }
});
const _exp4 = /*#__PURE__*/() => ({
  isMobileVanta
}) => isMobileVanta ? '0' : '10px 0';
const SearchWrraper = /*#__PURE__*/styled('div')({
  name: "SearchWrraper",
  class: "sxq9u9k",
  propsAsIs: false,
  vars: {
    "sxq9u9k-0": [_exp4()]
  }
});
interface LogoWrapperProps {
  isPayQRPage: boolean;
  isPubgGiveawayPage: boolean;
  isVesenniiRozygrysh2026Page: boolean;
  isDvoinoiShansNaPobeduPage: boolean;
  isDvoinoiShansNaPobeduResultsPage: boolean;
  isMobileVanta: boolean;
}
const _exp5 = /*#__PURE__*/() => ({
  isPayQRPage,
  isPubgGiveawayPage,
  isVesenniiRozygrysh2026Page,
  isDvoinoiShansNaPobeduPage,
  isDvoinoiShansNaPobeduResultsPage,
  theme
}) => isPayQRPage ? '#000000' : isPubgGiveawayPage ? '#222222' : isVesenniiRozygrysh2026Page ? '#102248' : isDvoinoiShansNaPobeduPage || isDvoinoiShansNaPobeduResultsPage ? '#2EA9BC' : theme.colors.bg.black;
const _exp6 = /*#__PURE__*/() => ({
  isMobileVanta
}) => isMobileVanta ? 'none' : 'block';
const _exp7 = /*#__PURE__*/() => ({
  isPayQRPage,
  isPubgGiveawayPage,
  isVesenniiRozygrysh2026Page,
  isDvoinoiShansNaPobeduPage,
  isDvoinoiShansNaPobeduResultsPage,
  theme
}) => isPayQRPage ? '#000000' : isPubgGiveawayPage ? '#222222' : isVesenniiRozygrysh2026Page ? '#102248' : isDvoinoiShansNaPobeduPage || isDvoinoiShansNaPobeduResultsPage ? '#2EA9BC' : theme.colors.bg.black;
const LogoWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "LogoWrapper",
  class: "lyhxy33",
  propsAsIs: false,
  vars: {
    "lyhxy33-0": [_exp5()],
    "lyhxy33-1": [_exp6()],
    "lyhxy33-2": [_exp7()]
  }
}));

require("./OldHeader.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldHeader.tsx");